import { BrowserModule, Title } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule, Routes } from '@angular/router';
import { AppComponent } from './app.component';
import { SDAIComponent } from './create-application/sdai-form/sdai/sdai.component';
import { SrpComponent } from './create-application/srp-form/srp/srp.component';
import { MyApplicationsComponent } from './manage-applications/my-applications/my-applications.component';
import { RegisterEmailComponent } from './manage-users/register_email/register_email.component';
import { RegisterComponent } from './manage-users/register/register.component';
import { LoginComponent } from './manage-users/login/login.component';
import { LogoutComponent } from './manage-users/logout/logout.component';
import { ResetPasswordComponent } from './manage-users/reset-password/reset-password.component';
import { AddressDetailsComponent } from './shared/components/address-details/address-details.component';
import { ApplicantDetailsComponent } from './shared/components/applicant-details/applicant-details.component';
import { RefDataDropdownComponent } from './shared/components/ref-data-dropdown/ref-data-dropdown.component';
import { PageNotFoundComponent } from './misc/page-not-found/page-not-found.component';
import { LoginService } from './shared/services/login.service';
import { FeeService } from './shared/services/fee.service';
import { CanActivateViaAuthGuard, CanActivateViaGeneralGuard } from './guards/can-activate-via-auth-guard';
import { CanActivateIfLoggedGuard } from './guards/can-activate-if-logged-guard';
import { CanActivateIfAdminGuard } from './guards/can-activate-if-admin-guard';
import { WelcomeComponent } from './manage-users/welcome/welcome.component';
import { RefDataService } from './shared/services/ref-data.service';
import { SpinnerComponent } from './shared/components/spinner/spinner.component';
import { ApplicationConfirmationComponent } from './shared/components/application-confirmation/application-confirmation.component';
import { LndApplicationConfirmationComponent } from './shared/components/lnd-application-confirmation/lnd-application-confirmation.component';
import { SdaiService } from './create-application/sdai-form/sdai.service';
import { SrpService } from './create-application/srp-form/srp.service';
import { AddressService } from './shared/services/address.service';
import { DataTableModule, EditorModule } from 'primeng/primeng';
import { CalendarModule } from 'primeng/calendar';
import { GeneralErrorComponent } from './misc/general-error/general-error.component';
import {
  TooltipModule, FileUploadModule, OverlayPanelModule, StepsModule, MessagesModule, MessageModule, DropdownModule, PaginatorModule, DialogModule, ButtonModule,
  InputSwitchModule, CardModule, TabViewModule
} from 'primeng/primeng';
import { ToastModule } from 'primeng/toast';
import { CheckboxModule } from 'primeng/checkbox';
import { TermsConditionsComponent } from './shared/components/terms-conditions/terms-conditions.component';
import { WorkrequestSrpComponent } from './create-application/srp-form/workrequest-srp/workrequest-srp.component';
import { PlumberDetailsComponent } from './shared/components/plumber-details/plumber-details.component';
import { PlumberDetailsMfbComponent } from './shared/components/plumber-details-mfb/plumber-details-mfb.component';
import { PlumberDetailsRwiComponent } from './shared/components/plumber-details-rwi/plumber-details-rwi.component';
import { ForgetPasswordComponent } from './manage-users/forget-password/forget-password.component';
import { UploadFileComponent } from './shared/components/upload-file/upload-file.component';
import { FileUploadService } from './shared/services/file-upload.service';
import { IppaymentComponent } from './shared/components/ippayment/ippayment.component';
import { IppaymentService } from './shared/services/ippayment.service';
import { IppaymentStatusComponent } from './shared/components/ippayment-status/ippayment-status.component';
import { RegistrationConfirmationComponent } from './manage-users/registration-confirmation/registration-confirmation.component';
import { UserDetailsComponent } from './manage-users/user-details/user-details.component';
import { MyDetailsComponent } from './manage-users/my-details/my-details.component';
import { ChangePasswordComponent } from './manage-users/change-password/change-password.component';
import { MyTeamComponent } from './manage-users/my-team/my-team.component';
import { GuestUserComponent } from './manage-users/guest-user/guest-user.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AllocateApplicationsComponent } from './manage-applications/allocate-applications/allocate-applications.component';
import { CanActivateIfSysAdminGuard } from './guards/can-activate-if-sysadmin-guard';
import { HttpClientModule } from '@angular/common/http';
import { BoeComponent } from './create-application/boe-form/boe/boe.component';
import { PfiComponent } from './create-application/pfi-form/pfi/pfi.component';
import { WorkrequestpfiComponent } from './create-application/pfi-form/workrequest-pfi/workrequest-pfi.component';
import { PfiService } from './create-application/pfi-form/pfi.service';
import { BoeService } from './create-application/boe-form/boe.service';
import { WorkrequestBoeComponent } from './create-application/boe-form/workrequest-boe/workrequest-boe.component';
import { WorkrequestChmComponent } from './create-application/chm-form/workrequest-chm/workrequest-chm.component';
import { CanActivateIfGuestGuard } from './guards/can-activate-if-guest-guard';
import { ChmComponent } from './create-application/chm-form/chm/chm.component';
import { UsrComponent } from './create-application/usr-form/usr/usr.component';
import { WorkrequestUsrComponent } from './create-application/usr-form/workrequest-usr/workrequest-usr.component';
import { OwnerDetailsComponent } from './shared/components/owner-details/owner-details.component';
import { UsrService } from './create-application/usr-form/usr.service';
import { ChmService } from './create-application/chm-form/chm.service';
import { CmpService } from './create-application/cmp-form/cmp.service';
import { WorkrequestCmpComponent } from './create-application/cmp-form/workrequest-cmp/workrequest-cmp.component';
import { LndWComponent } from './create-application/lnd-w-form/lnd-w/lnd-w.component';
import { WorkrequestLndWComponent } from './create-application/lnd-w-form/workrequest-lnd-w/workrequest-lnd-w.component';
import { LndWService } from './create-application/lnd-w-form/lnd-w.service';
import { LndNwComponent } from './create-application/lnd-nw-form/lnd-nw/lnd-nw.component';
import { LndNwService } from './create-application/lnd-nw-form/lnd-nw.service';
import { WorkrequestLndNwComponent } from './create-application/lnd-nw-form/workrequest-lnd-nw/workrequest-lnd-nw.component';
import { CmpNfComponent } from './create-application/cmp-form/cmp/cmp-nf.component';
import { CmpWfComponent } from './create-application/cmp-form/cmp/cmp-wf.component';
import { FireCmpComponent } from './create-application/cmp-form/fire-cmp/fire-cmp.component';
import { HydComponent } from './create-application/hyd-form/hyd/hyd.component';
import { WorkrequestHydComponent } from './create-application/hyd-form/workrequest-hyd/workrequest-hyd.component';
import { HydService } from './create-application/hyd-form/hyd.service';
import { SubmitButtonComponent } from './shared/components/submit-button/submit-button.component';
import { PostalAddressComponent } from './shared/components/postal-address/postal-address.component';
import { TermsConditionsInputComponent } from './shared/components/terms-conditions-input/terms-conditions-input.component';
import { TermsConditionsInputComponent2 } from './shared/components/terms-conditions-input-2/terms-conditions-input-2.component';
import { CheckAppStatusComponent } from './manage-applications/check-app-status/check-app-status.component';
import { DashboardComponent } from './shared/components/dashboard/dashboard.component';
import { CmpNfService } from './create-application/cmp-form/cmp-nf.service';
// import { GuestComponent } from './manage-users/guest/guest.component';
import { GeneratePaymentLinkComponent } from './manage-applications/generate-payment-link/generate-payment-link.component';
import { CanActivateIfTechCSOGuard } from './guards/can-activate-if-techcso-guard';
import { ApplicationOfflineComponent } from './shared/components/application-offline/application-offline.component';
import { CreateLogComponent } from './hydrant-log/create-log.component';
import { HydrantLogService } from './shared/services/hydrantlog.service';
import { HydrantLogComponent } from './hydrant-log/hydrant-log';
import { LogConfirmationComponent } from './hydrant-log/log-confirmation.component';
import { DatePipe } from '@angular/common';
import { PsaComponent } from './create-application/psa-form/psa/psa.component';
import { WorkrequestPsaComponent } from './create-application/psa-form/workrequest-psa/workrequest-psa.component'
import { PsaService } from './create-application/psa-form/psa.service';
import { AddressDetails2Component } from './shared/components/address-details2/address-details2.component';
import { ApplicantDetails2Component } from './shared/components/applicant-details2/applicant-details2.component';
import { OwnerDetails2Component } from './shared/components/owner-details2/owner-details2.component';
import { ConsultantDetailsComponent } from './shared/components/consultant-details/consultant-details.component';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { RadioButtonModule } from 'primeng/radiobutton';
import { UploadFile2Component } from './shared/components/upload-file2/upload-file2.component';
import { DisclaimerPsaComponent } from './create-application/psa-form/disclaimer-psa/disclaimer-psa.component';
import { TableModule } from 'primeng/table';
import { BlockCopyPasteDirective } from './shared/directives/block-copy-paste.directive';
import { UploadFile3Component } from './shared/components/upload-file3/upload-file3.component';
import { FileSizePipe } from './shared/components/upload-file3/upload-file3.component';
import { FeatureToggleService } from './shared/services/feature-toggle.service';
import { MfbComponent } from './create-application/mfb-form/mfb/mfb.component'
import { MfbService } from './create-application/mfb-form/mfb.service';
import { WorkdetailsMfbComponent } from './create-application/mfb-form/workdetails-mfb/workdetails-mfb.component';
import { RwiComponent } from './create-application/rwi-form/rwi/rwi.component';
import { RwiService } from './create-application/rwi-form/rwi.service';
import { WorkdetailsRwiComponent } from './create-application/rwi-form/workdetails-rwi/workdetails-rwi.component';

export const appRoutes: Routes = [
  {
    path: 'sdai',
    component: SDAIComponent,
    canActivate: [CanActivateViaAuthGuard]
  },
  {
    path: 'login',
    component: LoginComponent,
    canActivate: [CanActivateViaGeneralGuard]
  },
  // {
  //   path: 'guestuser',
  //   component: GuestUserComponent,
  //   canActivate: [CanActivateViaGeneralGuard]
  // },
  {
    path: 'srp',
    component: SrpComponent,
    canActivate: [CanActivateViaAuthGuard]
  },
  {
    path: 'myApplications',
    component: MyApplicationsComponent,
    canActivate: [CanActivateViaAuthGuard]
  },
  {
    path: 'myCreateHydrant',
    component: CreateLogComponent,
    canActivate: [CanActivateViaAuthGuard]
  },
  {
    path: 'myHydrantLogs',
    component: HydrantLogComponent,
    canActivate: [CanActivateViaAuthGuard]
  },
  {
    path: 'logConfirm',
    component: LogConfirmationComponent,
    canActivate: [CanActivateViaGeneralGuard]
  },
  {
    path: 'allocateApplications',
    component: AllocateApplicationsComponent,
    canActivate: [CanActivateIfSysAdminGuard]
  },
  {
    path: 'myDetails',
    component: MyDetailsComponent,
    canActivate: [CanActivateViaAuthGuard]
  },
  {
    path: 'myTeam',
    component: MyTeamComponent,
    canActivate: [CanActivateIfAdminGuard]
  },
  {
    path: 'registrations',
    component: MyTeamComponent,
    canActivate: [CanActivateIfAdminGuard]
  },
  {
    path: 'logout',
    component: LogoutComponent,
    canActivate: [CanActivateIfLoggedGuard]
  },
  {
    path: 'forgot_password',
    component: ForgetPasswordComponent
  },
  {
    path: 'change_password',
    component: ChangePasswordComponent,
    canActivate: [CanActivateViaAuthGuard]
  },
  {
    path: 'register_email',
    component: RegisterEmailComponent,
    canActivate: [CanActivateViaGeneralGuard]
  },
  {
    path: 'register',
    component: RegisterComponent,
    canActivate: [CanActivateViaGeneralGuard]
  },
  {
    path: 'reset/:token',
    component: ResetPasswordComponent
  },
  {
    path: 'error/:message',
    component: GeneralErrorComponent,
    canActivate: [CanActivateViaGeneralGuard]
  },
  {
    path: 'terms_of_use',
    component: TermsConditionsComponent,
    canActivate: [CanActivateViaGeneralGuard]
  },
  {
    path: 'terms_of_use/:appType',
    component: TermsConditionsComponent,
    canActivate: [CanActivateViaGeneralGuard]
  },
  {
    path: 'applicationConfirm',
    component: ApplicationConfirmationComponent,
    canActivate: [CanActivateViaAuthGuard]
  },
  {
    path: 'lndApplicationConfirm',
    component: LndApplicationConfirmationComponent,
    canActivate: [CanActivateViaAuthGuard]
  },
  {
    path: 'paymentStatus/:status/:damsapplicationid/:receipt/:emailSent',
    component: IppaymentStatusComponent
  },
  {
    path: 'checkoutIpPaymentSession',
    component: IppaymentComponent,
    canActivate: [CanActivateViaAuthGuard]
  },
  {
    path: 'registrationConfirm',
    component: RegistrationConfirmationComponent,
    canActivate: [CanActivateViaGeneralGuard]
  },
  {
    path: 'boe',
    component: BoeComponent,
    canActivate: [CanActivateViaAuthGuard]
  },
  {
    path: 'psa',
    component: PsaComponent,
    canActivate: [CanActivateViaAuthGuard]
  },
  {
    path: 'chm',
    component: ChmComponent,
    canActivate: [CanActivateViaAuthGuard]
  },
  {
    path: 'cmp-nf',
    component: CmpNfComponent,
    canActivate: [CanActivateViaAuthGuard]
  },
  {
    path: 'cmp-wf',
    component: CmpWfComponent,
    canActivate: [CanActivateViaAuthGuard]
  },
  {
    path: 'pfi',
    component: PfiComponent,
    canActivate: [CanActivateViaAuthGuard]
  },
  {
    path: 'usr',
    component: UsrComponent,
    canActivate: [CanActivateViaAuthGuard]
  },
  {
    path: 'lnd-w',
    component: LndWComponent,
    //canActivate: [CanActivateIfGuestGuard]
    canActivate: [CanActivateViaAuthGuard]
  },
  {
    path: 'lnd-w-guest',
    component: LndWComponent,
    data: { fromUrl: 'lnd-w-guest' },
    canActivate: [CanActivateViaAuthGuard]
  },
  {
    path: 'lnd-nw',
    component: LndNwComponent,
    //canActivate: [CanActivateIfGuestGuard]
    canActivate: [CanActivateViaAuthGuard]
  },
  {
    path: 'lnd-nw-guest',
    component: LndNwComponent,
    data: { fromUrl: 'lnd-nw-guest' },
    canActivate: [CanActivateViaAuthGuard]
  },
  {
    path: 'hyd',
    component: HydComponent,
    canActivate: [CanActivateViaAuthGuard]
  },
  {
    path: 'paymentLink',
    component: GeneratePaymentLinkComponent,
    canActivate: [CanActivateIfTechCSOGuard]
  },
  {
    path: 'checkAppStatus',
    component: CheckAppStatusComponent
  },
  {
    path: 'dashboard',
    component: DashboardComponent,
    //canActivate: [CanActivateIfLoggedGuard]
    canActivate: [CanActivateViaGeneralGuard]
  },
  //{
  //  path: 'guest',
  // component: GuestComponent,
  //  canActivate: [CanActivateViaGeneralGuard]
  //},
  {
    path: 'offline',
    component: ApplicationOfflineComponent
  },
  {
    path: 'rwi',
    component: RwiComponent,
    canActivate: [CanActivateViaAuthGuard]
  },
  {
    path: 'mfb',
    component: MfbComponent,
    canActivate: [CanActivateViaAuthGuard]
  },
  {
    path: '',
    //component: GuestComponent,
    component: DashboardComponent,
    canActivate: [CanActivateViaGeneralGuard]
  },
  {
    path: '**', redirectTo: ''
    // component: GuestComponent,
    // canActivate: [CanActivateViaGeneralGuard]
  }
];

@NgModule({
  declarations: [
    AppComponent,
    SDAIComponent,
    SrpComponent,
    MyApplicationsComponent,
    CreateLogComponent,
    HydrantLogComponent,
    LogConfirmationComponent,
    AllocateApplicationsComponent,
    RegisterComponent,
    RegisterEmailComponent,
    LoginComponent,
    LogoutComponent,
    ResetPasswordComponent,
    AddressDetailsComponent,
    ApplicantDetailsComponent,
    RefDataDropdownComponent,
    PageNotFoundComponent,
    WelcomeComponent,
    SpinnerComponent,
    ApplicationConfirmationComponent,
    LndApplicationConfirmationComponent,
    WorkrequestSrpComponent,
    PlumberDetailsComponent,
    PlumberDetailsMfbComponent,
    PlumberDetailsRwiComponent,
    GeneralErrorComponent,
    TermsConditionsComponent,
    ForgetPasswordComponent,
    UploadFileComponent,
    IppaymentComponent,
    IppaymentStatusComponent,
    RegistrationConfirmationComponent,
    UserDetailsComponent,
    MyDetailsComponent,
    ChangePasswordComponent,
    MyTeamComponent,
    GuestUserComponent,
    BoeComponent,
    PfiComponent,
    WorkrequestpfiComponent,
    WorkrequestBoeComponent,
    UsrComponent,
    WorkrequestUsrComponent,
    OwnerDetailsComponent,
    WorkrequestBoeComponent,
    ChmComponent,
    WorkrequestChmComponent,
    CmpNfComponent,
    CmpWfComponent,
    WorkrequestCmpComponent,
    LndWComponent,
    WorkrequestLndWComponent,
    LndNwComponent,
    WorkrequestLndNwComponent,
    FireCmpComponent,
    HydComponent,
    WorkrequestHydComponent,
    SubmitButtonComponent,
    TermsConditionsInputComponent,
    TermsConditionsInputComponent2,
    PostalAddressComponent,
    CheckAppStatusComponent,
    DashboardComponent,
    // GuestComponent,
    GeneratePaymentLinkComponent,
    ApplicationOfflineComponent,
    PsaComponent,
    WorkrequestPsaComponent,
    AddressDetails2Component,
    ApplicantDetails2Component,
    OwnerDetails2Component,
    ConsultantDetailsComponent,
    UploadFile2Component,
    UploadFile3Component,
    FileSizePipe,
    DisclaimerPsaComponent,
    BlockCopyPasteDirective,
    MfbComponent,
    WorkdetailsMfbComponent,
    RwiComponent,
    WorkdetailsRwiComponent,
  ],
  imports: [
    BrowserModule,
    FormsModule,
    ReactiveFormsModule,
    DataTableModule,
    CalendarModule,
    HttpClientModule,
    TooltipModule,
    CheckboxModule,
    FileUploadModule,
    OverlayPanelModule,
    StepsModule,
    MessagesModule,
    MessageModule,
    DropdownModule,
    PaginatorModule,
    DialogModule,
    ButtonModule,
    InputSwitchModule,
    CardModule,
    TabViewModule,
    ToastModule,
    EditorModule,
    BrowserAnimationsModule,
    AutoCompleteModule,
    RadioButtonModule,
    TableModule,
    TabViewModule,
    RouterModule.forRoot(appRoutes) // Add routes to the app
  ],
  providers: [
    Title,
    LoginService,
    CanActivateViaAuthGuard,
    CanActivateIfLoggedGuard,
    CanActivateIfAdminGuard,
    CanActivateIfSysAdminGuard,
    //CanActivateIfGuestGuard,
    CanActivateIfTechCSOGuard,
    CanActivateViaGeneralGuard,
    FeeService,
    RefDataService,
    SdaiService,
    SrpService,
    AddressService,
    FileUploadService,
    IppaymentService,
    PfiService,
    IppaymentService,
    BoeService,
    UsrService,
    ChmService,
    CmpService,
    CmpNfService,
    LndWService,
    LndNwService,
    PsaService,
    HydService,
    HydrantLogService,
    DatePipe,
    FeatureToggleService,
    MfbService,
    RwiService
  ],
  bootstrap: [AppComponent]
})

export class AppModule {
}



// WEBPACK FOOTER //
// ./src/app/app.module.ts